import React, { useState } from 'react';
import { GoldIcon, SilverIcon, PlatinumIcon } from '../icons/MetalIcons';

const WizardStepMetalType = ({ onNext, setWizardData, wizardData }) => {
  const [selectedMetal, setSelectedMetal] = useState(wizardData.metal_type || null);

  const metals = [
    {
      type: 'gold',
      name: 'Gold',
      description: 'The classic precious metal investment, known for stability and long-term value.',
      icon: <GoldIcon />
    },
    {
      type: 'silver',
      name: 'Silver',
      description: 'More affordable than gold, with investment value and industrial applications.',
      icon: <SilverIcon />
    },
    {
      type: 'platinum',
      name: 'Platinum',
      description: 'Rarer than gold, with significant industrial uses and investment potential.',
      icon: <PlatinumIcon />
    }
  ];

  const handleSelect = (metal) => {
    setSelectedMetal(metal);
    setWizardData({...wizardData, metal_type: metal});
  };

  const handleNext = () => {
    if (selectedMetal) {
      onNext();
    }
  };

  return (
    <div className="min-h-[450px] bg-gradient-to-br from-gray-50 to-gray-200 py-3 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Step Description */}
        <h2 className="text-center text-2xl font-bold text-gray-800 mb-2">Which metal would you like to acquire?</h2>
        <p className="text-center text-gray-600 mb-4">Choose which precious metal you'd like to start accumulating.</p>

        {/* Content Section */}
        <div className="flex justify-center">
          <div className="w-full max-w-3xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {metals.map((metal) => (
                <div
                  key={metal.type}
                  onClick={() => handleSelect(metal.type)}
                  className={`
                    relative bg-white rounded-2xl p-6 cursor-pointer
                    transition-all duration-300 ease-in-out
                    border-2 shadow-md min-h-[240px]
                    hover:transform hover:-translate-y-1 hover:shadow-xl
                    ${selectedMetal === metal.type
                      ? 'border-blue-500 shadow-blue-200 transform -translate-y-1'
                      : 'border-gray-200 hover:border-blue-500'
                    }
                  `}
                >
                  {selectedMetal === metal.type && (
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-blue-500/5 rounded-2xl animate-fadeIn"></div>
                  )}

                  <div className="relative z-10 flex flex-col items-center text-center h-full">
                    <div className="w-20 h-20 mb-2 flex items-center justify-center opacity-80 transition-opacity duration-300 hover:opacity-100">
                      {metal.icon}
                    </div>

                    <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                      {metal.name}
                    </h3>

                    <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                      {metal.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation Section */}
        <div className="flex justify-end mt-4 max-w-3xl mx-auto">
          <button
            onClick={handleNext}
            disabled={!selectedMetal}
            className={`px-6 py-2 rounded-full font-bold transition-colors ${
              selectedMetal
                ? 'bg-black text-white hover:bg-gray-800'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Continue
            <i className="bi bi-arrow-right ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WizardStepMetalType;


